import {Notification, NotificationIcon} from '@store/notifications/notifications.types';

export const FALLBACK_NOTIFICATION: Notification = {
  id: 0,
  patronId: 0,
  patronNotificationType: 'ACCOUNT_ACTIVATED',
  subject: '',
  message: '',
  emailSent: false,
  smsSent: false,
  active: false,
  viewed: false,
  created: '',
  modified: '',
};

export const FALLBACK_NOTIFICATION_ICON: NotificationIcon = {
  iconName: 'info',
  iconClasses: 'text-on-surface-variant material-icons-outlined'
}
